import {QueryStatus} from '@reduxjs/toolkit/query/react';
import type {LoadStatus} from 'api/types';

export const queryStatusToLoadStatus = (status: QueryStatus): LoadStatus => {
  switch (status) {
    case QueryStatus.uninitialized:
      return 'NotLoaded';
    case QueryStatus.pending:
      return 'Loading';
    case QueryStatus.fulfilled:
      return 'Loaded';
    case QueryStatus.rejected:
      return 'Failed';
  }

  return 'NotLoaded';
};
